<template>
  <div v-if="item" class="text-center">
    <transaction-chat :id="id" />

    <h3 class="text-success">
      {{ "order" | setText("Заказ") }} #{{ item.order.id }}
    </h3>

    <div
      class="mt-5"
      v-if="item.order.status && item.order.status.code == 'cancel'"
    >
      <h1><span class="ti-close"></span></h1>
      <h3>
        {{ "partner_cancel_this_order" | setText("Партнер отменил заказ") }}
      </h3>

      <button @click="refresh" class="btn btn-icon mw">
        <span class="ti-reload"></span>
        {{ "check_change" | setText("Проверить изменение") }}
      </button>
      <div class="mt-4">
        <div class="border">
          <h3>{{ "set_status" | setText("Установить статус") }}</h3>
          <select
            v-model="item.status"
            class="form-control mb-4"
            @change="updateItemData(['status'], [], 'Установка статуса')"
          >
            <option :value="status.id" v-for="(status, i) in statuses" :key="i">
              {{ status.key | setText(status.title) }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div v-else>
      <div>
        <h4 class="m-0 text-info" v-if="item.order.status">
          <span>{{ "partner_status" | setText("Статус партнера") }}: </span>
          <span v-if="item.order.status">
            {{ item.order.status.name }}
          </span>
          <span v-else> Без статуса </span>
        </h4>
      </div>
      <div>
        <h4 class="m-0" v-if="item.display_status">
          <span>{{ "your_status" | setText("Ваш статус") }}: </span>
          <span v-if="item.display_status">
            {{ item.display_status }}
          </span>
          <span v-else> Без статуса </span>
        </h4>
      </div>
      <div>
        <h4 v-if="item.order_user_phone" class="m-0">
          <span>
            {{ item.order_user_phone }}
          </span>
        </h4>
      </div>

      <div class="border">
        <h3>{{ "set_status" | setText("Установить статус") }}</h3>
        <select
          v-model="item.status"
          class="form-control mb-4"
          @change="updateItemData(['status'], [], 'Установка статуса')"
        >
          <option :value="status.id" v-for="(status, i) in statuses" :key="i">
            {{ status.key | setText(status.title) }}
          </option>
        </select>

        <checkbox
          @change="updateItemData(['is_sms'], [], 'Необходимо получать смс')"
          :value="true"
          name="is_sms"
          v-model="item.is_sms"
          color="#2c75ff"
          >{{ "is_sms" | setText("Потребуется СМС") }}</checkbox
        >
      </div>

      <div class="border">
        <h3>{{ "order_info" | setText("Информация заказа") }}</h3>

        <div class="row">
          <div class="col-12 col-lg-6">
            <div>
              <span class="text-info">Контактный номер</span>:
              {{ item.order.client.phone }}
            </div>
            <div>
              <span class="text-info">Фамилия</span>:
              {{ item.order.client.last_name }}
            </div>
            <div>
              <span class="text-info">Имя</span>:
              {{ item.order.client.first_name }}
            </div>
            <div>
              <span class="text-info">Номер паспорта</span>:
              {{ item.order.client.passport_number }}
            </div>
            <div>
              <span class="text-info">ПИНФЛ</span>:
              {{ item.order.client.PINFL }}
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div>
              <span class="text-info">Фото паспорта</span>:
              <a target="_blank" :href="item.order.client.passport_1">{{
                "download" | setText("Скачать")
              }}</a>
            </div>
            <div>
              <span class="text-info">Прописка или обратная сторона ID</span>:
              <a target="_blank" :href="item.order.client.passport_3">{{
                "download" | setText("Скачать")
              }}</a>
            </div>
            <div>
              <span class="text-info">Селфи с паспортом или ID</span>:
              <a target="_blank" :href="item.order.client.passport_4">{{
                "download" | setText("Скачать")
              }}</a>
            </div>
            <div v-if="item.order.card">
              <span class="text-info">Номер карты: </span>:
              {{ item.order.card.card_number }}
            </div>
            <div v-if="item.order.card">
              <span class="text-info">Дата: </span>:
              {{ item.order.card.exp }}
            </div>
          </div>
        </div>

        <div v-if="item.order.purchases.length">
          <h3>Товары</h3>
          <table class="table border">
            <thead>
              <tr>
                <td>{{ "name" | setText("Название") }}</td>
                <td>{{ "qty" | setText("Количество") }}</td>
                <td>{{ "price" | setText("Цена") }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(purchase, key) in item.order.purchases" :key="key">
                <td>
                  {{ key + 1 }}.
                  {{ purchase.name }}
                </td>
                <td>
                  {{ purchase.quantity }}
                </td>
                <td>{{ purchase.price_total | spaceBetweenNumber }} UZS</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h4>
          <span class="text-info"
            >{{ "total_price" | setText("Общая стоимость") }}:</span
          >
          {{ item.order.price_total | spaceBetweenNumber }} UZS
        </h4>

        <button @click="refresh" class="btn btn-icon mw">
          <span class="ti-reload"></span>
          {{ "check_change" | setText("Проверить изменение") }}
        </button>
      </div>

      <div class="border" v-if="item.is_sms">
        <h3>{{ "check_sms" | setText("Смс код от клиента") }}</h3>

        <div v-if="item.code">
          <p>{{ "code" | setText("Отправленный код") }}:</p>
          <h2>{{ item.code }}</h2>
        </div>

        <h3 v-if="timer > 0" class="text-info">
          {{ "wait_60_second" | setText("Ожидайте: ") }} {{ timer }}
          {{ "second" | setText("сек.") }}
        </h3>

        <button v-else @click="refresh" class="btn btn-icon mw">
          <span class="ti-reload"></span>
          {{ "check" | setText("Проверить") }}
        </button>
      </div>

      <div
        :class="`border text-center ${
          item.status == 1 && !done ? '' : 'opacity'
        }`"
      >
        <h3>
          {{ "send_limit" | setText("Отправить лимит") }}
        </h3>

        <h4>
          Желаемый срок рассрочки: {{ item.month }}
          {{ "mo" | setText }}
        </h4>

        <label>Изменить срок рассрочки</label>
        <select
          class="form-control mb-3"
          @change="clearPercent"
          v-model="item.month"
        >
          <option
            v-for="(cond, key) in item.partner.conditionals"
            :value="cond.month"
            :key="key"
          >
            {{ cond.month }}м. -  {{ cond.coefficient }}%
          </option>
        </select>

        <div class="row">
          <div class="col-12 col-md-6">
            <fg-input
              :type="`text`"
              :label="`Введите лимит`"
              :labelKey="`input_limit`"
              v-model="formattedLimit"
              placeholder="Например: 1000000"
            ></fg-input>
          </div>
          <div class="col-12 col-md-6">
            <fg-input
              :type="`number`"
              :label="`Введите процент (%)`"
              :labelKey="`percent`"
              placeholder="Например: 43"
              v-model="item.percent"
            ></fg-input>
          </div>
          <div class="col-12 col-md-12">
            <label>Комментарий для покупателя</label>
            <textarea
              class="form-control mt-2"
              placeholder="Комментарий"
              v-model="item.limit_verdict"
            ></textarea>
          </div>
        </div>

        <button
          v-if="!done"
          @click="
            updateItemData(
              ['limit', 'limit_verdict', 'percent', 'month'],
              [],
              'Установка лимита'
            )
          "
          class="btn btn-info btn-icon mw mt-4"
        >
          {{ "apply" | setText("Применить") }}
        </button>

        <hr />

        <div v-if="item.limit_verdict">
          <small> {{ item.limit_verdict }} </small>
        </div>

        <h4>
          <div class="text-info">{{ item.percent }}% на {{ item.month }} мес.</div>

          <div v-if="item.price">
            <div>
              {{ "price_partner" | setText("Общая стоимость") }}:
              {{ item.price | spaceBetweenNumber }} UZS
            </div>
          </div>
          <div v-if="item.price_per_month">
            <div>
              {{ "price_partner_mo" | setText("Цена в месяц") }}:
              {{ item.price_per_month | spaceBetweenNumber }} UZS
            </div>
          </div>
        </h4>
      </div>

      <div :class="`border text-center ${!done ? '' : 'opacity'}`">
        <h3>
          {{ "upload_act_now" | setText("Загрузить договор") }}
          <span class="ti-upload"></span>
        </h3>

        <div v-if="item.client_confirmed">
          <h4>
            {{
              "client_confirm"
                | setText("Клиент согласен, готов заключить договор")
            }}
          </h4>

          <div class="mb-3">
            <div class="row">
              <div class="col-12 col-md-6">
                <fg-input
                  :type="`text`"
                  :label="`Введите номер договора`"
                  :labelKey="`input_exchange_id`"
                  v-model="item.exchange_id"
                  placeholder="Например: DF1233"
                ></fg-input>
              </div>
              <div class="col-12 col-md-6">
                <fg-input
                  :type="`date`"
                  :label="`Введите дату договора`"
                  :labelKey="`transaction_at`"
                  placeholder="Например: 04.10.2023"
                  v-model="item.transaction_at"
                ></fg-input>
              </div>
            </div>

            <button
              v-if="!done"
              @click="
                updateItemData(
                  ['exchange_id', 'transaction_at'],
                  [],
                  'Генерация договора',
                  true
                )
              "
              class="btn btn-info btn-icon mw mx-2"
            >
              {{ "apply" | setText("Применить") }}
            </button>

            <a
              style="opacity: 0; width: 0; padding: 0; margin: 0"
              ref="downloadDoc"
              v-if="item.transaction_at && item.exchange_id"
              target="_blank"
              class="btn btn-warning mx-2"
              :href="`${$store.state.host}/api/v1/pdf/all_goods/${item.id}`"
              ><span class="ti-file"></span
            ></a>
          </div>

          <zip-upload
            v-if="!done"
            v-model="item.act_original"
            :title="'Выберите PNG/JPG/PDF'"
            @input="
              updateItemData(
                ['act_original'],
                [],
                'Загрузка договора от партнера'
              )
            "
          />
        </div>
        <div v-else>
          <h4>
            {{
              "wait_client_status" | setText("Ожидание подтверждения клиента")
            }}
          </h4>

          <h4 v-if="timer > 0" class="text-info">
            {{ "wait_60_second" | setText("Ожидайте: ") }} {{ timer }}
            {{ "second" | setText("сек.") }}
          </h4>

          <button v-else @click="refresh" class="btn btn-icon mw">
            <span class="ti-reload"></span>
            {{ "check" | setText("Проверить") }}
          </button>
        </div>

        <a
          v-if="item.act_original"
          target="_blank"
          class="btn btn-success mw mt-4"
          :href="item.act_original"
          >{{ "download_check" | setText("Скачать, проверить") }}</a
        >
      </div>

      <div
        :class="`border text-center ${
          item.act_original && !done ? '' : 'opacity'
        }`"
      >
        <h3>
          {{ "wait_order" | setText("Ожидание договора с подписью") }}
          <span class="ti-timer"></span>
        </h3>

        <div>
          <a
            v-if="item.act"
            target="_blank"
            class="btn btn-success mw mb-4"
            :href="item.act"
            >{{ "download" | setText("Скачать") }}</a
          >
        </div>

        <h4 v-if="timer > 0" class="text-info">
          {{ "wait_60_second" | setText("Ожидайте: ") }} {{ timer }}
          {{ "second" | setText("сек.") }}
        </h4>

        <button v-else @click="refresh" class="btn btn-icon mw">
          <span class="ti-reload"></span>
          {{ "check" | setText("Проверить") }}
        </button>
      </div>

      <div
        :class="`border text-center ${
          item.act && item.client_confirmed && !done ? '' : 'opacity'
        }`"
      >
        <div v-if="!done">
          <!-- <checkbox
          :value="true"
          name="roles"
          v-model="data.client_confirmed"
          color="#2c75ff"
          >{{
            "client_confirmed" | setText("Клиенту можно передавать товар")
          }}</checkbox
        > -->
          <checkbox
            :value="true"
            name="roles"
            v-model="data.system_confirmed"
            color="#2c75ff"
            >{{
              "system_confirmed_text"
                | setText(
                  "Я все проверил, согласен с договором. Клиент может забрать устройство"
                )
            }}</checkbox
          >

          <button
            v-if="item.client_confirmed"
            @click="
              updateItemData(
                ['system_confirmed'],
                ['system_confirmed'],
                'Партнеры подтвердили заказ'
              )
            "
            class="btn btn-info btn-icon mw mt-4"
          >
            {{ "apply" | setText("Применить") }}
          </button>
        </div>
        <div v-else>
          <h2>{{ "all_done" | setText("Заказ успешно оформлен") }}</h2>
          <h4>{{ "not_remind" | setText("Установите стаус - Выполнен") }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  cardUpdate,
  cardContent,
  toFormData,
  errorNotify,
} from "@/plugins/functions";
import { logger } from "../../../plugins/functions";

export default {
  data: () => ({
    timer: 0,
    cardLink: "partner/transactions",
    cardSetLink: "partner/transactions",
    item: null,
    data: {
      percent: "",
      limit: "",
      limit_verdict: null,
      is_sms: false,
      system_confirmed: false,
      client_confirmed: false,
    },
    statuses: [
      { id: "0", title: "Новый", key: "new" },
      { id: "1", title: "Начать процесс", key: "proccess" },
      { id: "-1", title: "Отменить", key: "cancel" },
      { id: "2", title: "Выполнен", key: "done" },
    ],
  }),

  mounted() {
    setInterval(() => {
      this.timer--;
    }, 1000);
  },

  props: ["id"],
  async created() {
    this.refresh();
  },

  computed: {
    formattedLimit: {
      get() {
        let val = this.item.limit;

        if (!val) {
          return "";
        }
        val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

        if (!val || val === NaN) return 0;

        return val;
      },
      set(newValue) {
        console.log(newValue);
        if (newValue === NaN) {
          alert(2);
          this.item.limit = 0;
        }

        this.item.limit = parseFloat(newValue.replace(/\s/g, ""));
      },
    },
    done() {
      return (
        this.item && this.item.system_confirmed && this.item.client_confirmed
      );
    },
  },

  methods: {
    clearPercent() {
      this.item.percent = 0;
    },
    async refresh() {
      this.item = await this.cardContent(this.cardLink, this.id);
      this.timer = 10;
    },
    cardUpdate: cardUpdate,
    cardContent: cardContent,

    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );

      if (item && item.id) {
        this.item = item;
      }
    },

    async updateItemData(
      keys = [],
      newKeys = [],
      msg = "",
      loadDocument = false
    ) {
      try {
        if (msg) {
          logger(this.$http, {
            name: msg,
            description: "",
            model_type: "order",
            model_id: this.item.order.id,
          });
        }
      } catch (error) {}

      let data = {};
      let tempData = this.item;

      if (newKeys.length) {
        for (let i = 0; i < newKeys.length; i++) {
          let val = this.data[newKeys[i]];

      

          if (val === true) {
            val = 1;
          } else if (val === false) {
            val = 0;
          }

          data[newKeys[i]] = val;
        }
      } else {
        for (let i = 0; i < keys.length; i++) {
          let val = tempData[keys[i]];
          if (val === true) {
            val = 1;
          } else if (val === false) {
            val = 0;
          }

          // if (keys[i] === "transaction_at" && !val) {
          //   this.$notify({
          //     title: "!!!",
          //     message: "Введите дату договора",
          //     horizontalAlign: "right",
          //     verticalAlign: "top",
          //     type: "warning",
          //   });
          //   return false;
          // }

          // if (keys[i] === "exchange_id" && !val) {
          //   this.$notify({
          //     title: "!!!",
          //     message: "Введите номер договора",
          //     horizontalAlign: "right",
          //     verticalAlign: "top",
          //     type: "warning",
          //   });
          //   return false;
          // }

          data[keys[i]] = val;
        }
      }
      this.$loading(true);
      this.$http({
        method: "post",
        data: toFormData({
          _method: "put",
          ...data,
        }),
        url: `${this.cardLink}/${this.id}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.$notify({
            title: "Успешно",
            message: "Вы успешно применили данные",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          this.$store.dispatch("setLastUpdate", new Date());
          this.item = response.data.data;

          if (loadDocument) {
            try {
              this.$refs.downloadDoc.click();
            } catch (error) {}
          }
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>
<style>
</style>
